import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Parser from 'html-react-parser';
import { SavePostingSelectors } from '../../../../ducks/savePosting';
import {
  Subtitle,
  SectionContainer,
  ButtonsContainer,
  InputVideo,
  ErrorMessage,
  AddButton,
  VideoList,
  Video,
  VideoDetail,
  TrashIcon
} from './styles.js';
import { ModuleWrapper } from '../moduleWrapper';
import {
  getVideos360,
  addMultimedia,
  MultimediaType,
  MultimediaCollection,
  deleteMultimedia,
  validateVideo360State,
  validateVideo360
} from '../../../../ducks/multimedia';

export const Videos360 = ({
  register,
  errors,
  trigger,
  setValue,
  getValues,
  setValidateVideo,
  validateVideo,
  device,
  clearErrors,
  watch,
  setError,
  showErrorSnackbar
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { tour360 } = useSelector(getVideos360);
  const { validation360Loading, validationVideo360Success, validationVideo360Error, validatedVideo360 } = useSelector(
    validateVideo360State
  );
  const { saving } = useSelector(SavePostingSelectors.getSavePostingState);

  const watchVideo = watch('video360');

  const deleteVideo = id => {
    dispatch(deleteMultimedia(id, MultimediaCollection.VIDEO360));
  };

  const addVideo = () => {
    const videoUrl = getValues('video360');
    if (!videoUrl) return;

    const objVideo = {
      key_video: videoUrl,
      multimediaTypeEnum: MultimediaType.TOUR360
    };
    setValue('video360', '');
    dispatch(addMultimedia(objVideo, MultimediaCollection.VIDEO360));
  };

  // Manejo de la validación inicial
  useEffect(() => {
    const processValidation = async () => {
      const videoUrl = getValues('video360');
      // Validar primero localmente (tipo 'basicUrlCheck' de Yup):
      const localValidation = await trigger('video360');
      // Si pasa la validación local, se inicia validación del servicio
      if (localValidation) {
        dispatch(validateVideo360(videoUrl));
      }
    };

    if (validateVideo) {
      processValidation();
    }
    return setValidateVideo(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateVideo]);

  // Reacciona a cambios en el estado de validación:
  useEffect(() => {
    // Solo procesamos cuando la validación ha terminado
    if (validatedVideo360 && !validation360Loading) {
      if (validationVideo360Success) {
        addVideo();
      }
      if (!validationVideo360Success && !validationVideo360Error) {
        setError('video360', {
          type: 'check360Url' // Diferente del 'basicUrlCheck' de Yup
        });
      }
      if (validationVideo360Error) {
        showErrorSnackbar('video360ErrorFetch', t('professionalPubli.multimedia.video360.errorGeneric'));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation360Loading, validationVideo360Success, validationVideo360Error, validatedVideo360]);

  useEffect(() => {
    // Limpiamos errores en carga inicial
    clearErrors('video360');
    if (saving) {
      // Limpiamos error cuando se inicia el guardado del step
      clearErrors('video360');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saving]);

  return (
    <ModuleWrapper padding='0px'>
      <Subtitle data-publi='multimedia-video360-subtitle'>
        {Parser(t('professionalPubli.multimedia.video360.subtitle'))}
      </Subtitle>
      <SectionContainer data-publi='multimedia-video360-sectionContainer'>
        <ButtonsContainer device={device} data-publi='multimedia-video360-buttonContainer'>
          <div className='input-container'>
            <InputVideo
              data-publi='multimedia-360-input'
              className={errors.video360 && 'error'}
              type='text'
              disabled={tour360.length >= 1}
              name='video360'
              onKeyDown={evt => {
                if (evt.key === 'Enter') evt.preventDefault();
              }}
              ref={register}
              placeholder={t('professionalPubli.multimedia.video360.placeholder')}
              onFocus={() => clearErrors('video360')}
            />
            {(errors.video360?.type === 'check360Url' || errors.video360?.type === 'checkBasicUrl') && (
              <ErrorMessage data-publi='multimedia-video360-error-invalidUrl'>
                {t('professionalPubli.multimedia.video360.error.invalid')}
              </ErrorMessage>
            )}
          </div>
          <AddButton
            data-publi='multimedia-360-button-add'
            type='button'
            disabled={tour360.length >= 1 || watchVideo === '' || errors.video360}
            device={device}
            onClick={() => {
              if (tour360.length < 1) {
                setValidateVideo(true);
              }
            }}
          >
            {t('professionalPubli.multimedia.video360.add')}
          </AddButton>
        </ButtonsContainer>
        {tour360.length > 0 && (
          <VideoList data-publi='multimedia-360-itemlist' device={device}>
            {tour360.map(video => (
              <Video data-publi={`multimedia-360-item-${video.order}`} key={video.id}>
                <iframe
                  data-publi={`multimedia-360-item-${video.order}-iframe`}
                  title={video.videoId}
                  width='100%'
                  height='100%'
                  src={video.key_video}
                  frameBorder='0'
                  allowFullScreen=''
                />
                <VideoDetail data-publi={`multimedia-360-item-${video.key_video}-videoDetail`} device={device}>
                  <span data-publi={`multimedia-360-item-${video.key_video}-videoDetail-span`}>{video.key_video}</span>
                  <TrashIcon
                    data-publi={`multimedia-360-item-${video.key_video}-button-delete`}
                    onClick={() => deleteVideo(video.id)}
                  />
                </VideoDetail>
              </Video>
            ))}
          </VideoList>
        )}
      </SectionContainer>
    </ModuleWrapper>
  );
};
